import { createNamedApi } from '@essent/common';

import { PutInitiateFlowService } from './put-initiate-flow.service';

export const putInitiateFlowApi = createNamedApi(
  '[become-a-customer] Put Initiate Flow',
  PutInitiateFlowService
);
